/* unplugin-vue-components disabled */import { render } from "./Products.vue?vue&type=template&id=243184ad"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=243184ad&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__